import { ResponsiveContainer, LineChart, Line, Tooltip, YAxis } from 'recharts';

const overfitted = [
  { x: 0, v: 100 }, { x: 1, v: 108 }, { x: 2, v: 116 }, { x: 3, v: 125 },
  { x: 4, v: 134 }, { x: 5, v: 144 }, { x: 6, v: 155 }, { x: 7, v: 167 },
  { x: 8, v: 180 }, { x: 9, v: 194 }, { x: 10, v: 210 },
];

const realistic = [
  { x: 0, v: 100 }, { x: 1, v: 104 }, { x: 2, v: 96 }, { x: 3, v: 112 },
  { x: 4, v: 106 }, { x: 5, v: 118 }, { x: 6, v: 113 }, { x: 7, v: 128 },
  { x: 8, v: 122 }, { x: 9, v: 140 }, { x: 10, v: 155 },
];

const tipStyle = {
  background: 'rgba(17,24,39,0.95)',
  border: '1px solid rgba(75,85,99,0.5)',
  borderRadius: 6,
  fontSize: 11,
  fontFamily: 'ui-monospace, monospace',
};

export default function OverfittedVsRealisticMock() {
  return (
    <div className="platform-mock">
      <div className="platform-mock-header">
        <span className="dot" /> Overfitted vs Realistic
      </div>
      <div className="platform-mock-body">
        <div className="mock-compare">
          <div className="mock-compare-panel">
            <div className="mock-compare-title" style={{ color: '#ef4444' }}>
              Suspiciously Smooth (Overfitted)
            </div>
            <div style={{ width: '100%', height: 60 }}>
              <ResponsiveContainer>
                <LineChart data={overfitted} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
                  <YAxis hide domain={['dataMin', 'dataMax']} />
                  <Tooltip contentStyle={tipStyle} labelStyle={{ display: 'none' }} formatter={(v: number) => [`$${v}`, 'Equity']} cursor={{ stroke: 'rgba(255,255,255,0.15)' }} />
                  <Line type="monotone" dataKey="v" stroke="#ef4444" strokeWidth={1.5} dot={false} activeDot={{ r: 3, fill: '#ef4444' }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div style={{ fontSize: '0.5625rem', color: '#6b7280', marginTop: '0.25rem' }}>
              Almost no drawdowns &mdash; likely curve-fitted to past data
            </div>
          </div>
          <div className="mock-compare-panel">
            <div className="mock-compare-title" style={{ color: '#22c55e' }}>
              Realistic (Robust)
            </div>
            <div style={{ width: '100%', height: 60 }}>
              <ResponsiveContainer>
                <LineChart data={realistic} margin={{ top: 4, right: 4, bottom: 0, left: 4 }}>
                  <YAxis hide domain={['dataMin', 'dataMax']} />
                  <Tooltip contentStyle={tipStyle} labelStyle={{ display: 'none' }} formatter={(v: number) => [`$${v}`, 'Equity']} cursor={{ stroke: 'rgba(255,255,255,0.15)' }} />
                  <Line type="monotone" dataKey="v" stroke="#22c55e" strokeWidth={1.5} dot={false} activeDot={{ r: 3, fill: '#22c55e' }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
            <div style={{ fontSize: '0.5625rem', color: '#6b7280', marginTop: '0.25rem' }}>
              Natural pullbacks and recoveries &mdash; a healthier sign
            </div>
          </div>
        </div>
      </div>
      <div className="platform-mock-caption">
        A perfect curve is a warning sign. Real markets produce bumps.
      </div>
    </div>
  );
}
